// extracted by mini-css-extract-plugin
export default {"container_start":"StartProject_container_start__5C4V8"};